import { render, staticRenderFns } from "./r-maps-panel.vue?vue&type=template&id=5b05b382"
import script from "./r-maps-panel.vue?vue&type=script&lang=js"
export * from "./r-maps-panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b05b382')) {
      api.createRecord('5b05b382', component.options)
    } else {
      api.reload('5b05b382', component.options)
    }
    module.hot.accept("./r-maps-panel.vue?vue&type=template&id=5b05b382", function () {
      api.rerender('5b05b382', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/utils/r-maps-panel.vue"
export default component.exports